export const environment = {
    revenuesRootURL: 'https://api-payment.project2.epa.ohio.gov',
    ebizRootURL: 'https://epaproject2apps.epa.ohio.gov',
    clientID : '985a589e-6e02-4748-bdd2-cac52a2fe15a',
    redirectURI: 'https://payment.project2.epa.ohio.gov/online-payments/payment-home',
    recaptchaSiteKey: '6LfLWtwqAAAAAGaJyvfWqBYRqT1whMlPwZQY-Jm2',
    recaptchaAPIKey: 'AIzaSyAA44fa_k5D5MQpoXEHokUWj-MFU8IyfE0'
};
